define('modules/editor/models/property_groups/label',['require','exports','module','./base','lib/util','../../behaviours/localizable_property_group'],function (require, exports, module) {
  "use strict";
  var Base = require("./base"),
      util = require("lib/util");
  module.exports = Base.extend({
    name: "label",
    properties: ["text", "fontStyle", "fontFamily", "fontSize"],
    localizableAttrs: ["text"],
    generateStyles: function($el, id){
      return [
        {
          selector: "#" + id + " a.btn",
          rules: {
            "font-family": this.get("fontFamily"),
            "font-size": this.get("fontSize") + "px",
            "font-weight": this.get("fontStyle")
          }
        }
      ];
    },
    applyStyles: function($el){
      var theLink = $el.find("span.btn-label");
      theLink.html(this.get("text"));
    },
    validators: {
      "fontSize": function(attrs){
        var value = parseInt(attrs.fontSize);
        return this.isNumber(value) && this.isInteger(value) && this.isInRange(value,1,60);
      },
      text: function(attrs){
        return attrs.text !== "";
      }
    }
  });

  util.mixin(module.exports, require("../../behaviours/localizable_property_group"));
});
